import { NewsLinkModel } from '../models/news-link.model';

//Adapter para transformar dados da API em NewsLinkModel
export class NewsLinkAdapter {
  //Converte um único item da API para NewsLinkModel

  static fromApi(response: any): NewsLinkModel {
    const data = response.data || response;

    return {
      id: data.id,
      title: data.title,
      description: data.description,
      url: data.url,
      type: data.type,
      active: data.active,
      creationDate: data.creationDate,
      updateDate: data.updateDate,
      userNameCreate: data.userNameCreate,
      userNameUpdate: data.userNameUpdate,
    };
  }

  /**
   * Converte array de items da API para array de NewsLinkModel
   * Ordena por data de criação (mais recente primeiro)
   */
  static fromApiArray(response: any): NewsLinkModel[] {
    const dataArray = response.data || response;

    if (!Array.isArray(dataArray)) {
      return [];
    }

    return dataArray
      .map((item: any) => this.fromApi({ data: item }))
      .sort(
        (a, b) =>
          new Date(b.creationDate).getTime() -
          new Date(a.creationDate).getTime(),
      );
  }
}
